// Category dropdown functionality
document.addEventListener('DOMContentLoaded', function() {
  const dropdownButton = document.querySelector('.dropdown-button');
  const dropdownMenu = document.querySelector('.dropdown-menu');
  
  if (dropdownButton && dropdownMenu) {
    // Toggle dropdown on button click
    dropdownButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Toggle the hidden class
      dropdownMenu.classList.toggle('hidden');
    });
    
    // Keep dropdown open when hovering over it
    dropdownMenu.addEventListener('mouseenter', function() {
      // Make sure it stays visible
      dropdownMenu.classList.remove('hidden');
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.dropdown')) {
        dropdownMenu.classList.add('hidden');
      }
    });
    
    // Close dropdown when pressing escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        dropdownMenu.classList.add('hidden');
      }
    });
  }
});
